
import {
  defineComponent,
  computed,
} from 'vue';

import LazyBackgroundMedia from '@/components/LazyBackgroundMedia.vue';

export default defineComponent({
  components: {
    LazyBackgroundMedia,
  },

  props: {
    anchorId: {
      type: String,
      required: false,
      default: () => null,
    },
    mediaId: {
      type: String,
      required: false,
      default: () => '0',
    },
    mediaSizes: {
      type: String,
      required: false,
      default: () => btoa('null'),
    },
    mediaAlt: {
      type: String,
      required: false,
      default: () => '',
    },
    background: {
      type: String,
      required: false,
      default: () => 'white',
    },
    gradient: {
      type: String,
      required: false,
      default: () => 'none',
    },
  },

  setup(props) {
    const backgroundClass = [];
    if (props.gradient !== 'none') {
      backgroundClass.push(`gradient-${props.gradient}`);
    }

    const sectionClass = computed<string[]>(() => {
      const sectionClasses: string[] = [];

      sectionClasses.push(`bg-${props.background}`);

      return sectionClasses;
    });

    return {
      sectionClass,
      backgroundClass,
    };
  },
});
